<template>
    <div>
        <!-- Begin Page Content -->
        <div class="medical-records Calendar-section">
            <div class="row">
                <div class="col-md-12 col-12 mb-4">
                    <div class="card border-0">
                        <div class="card-body p-0">
                            <div class="bg-white border-radius-5 p-4">
                                <div class="row no-gutters">
                                    <div class="col-md-4 pr-3">
                                        <figure class="border-bottom pb-4 mb-4 profli-pic"><img src="../../../../static/website/images/dr-image.svg" alt="" /></figure>
                                        <h2>Dr. Shabnam Das Kar, MD, FMNM</h2>
                                        <p>Specialist in Functional and Metabolic Medicine</p>
                                        <h6><strong>Experience:</strong>10 Years</h6>
                                    </div>
                                    <div class="col-md-8 pl-3">
                                        <h3>Salect a Date & Time</h3>
                                        <div class="row no-gutters">
                                            <div class="col-md-8 pr-3">
                                                <figure class="mb-0 calendar-pic">
                                                    <img src="../../../../static/website/images/calendar.png" alt="" />
                                                </figure>
                                            </div>
                                            <div class="col-md-4 pl-3">
                                                <h6>Thursday , 13 May</h6>
                                                <ul class="select-book mt-3">
                                                    <li class="mb-3"><a href="#">1:00 PM</a></li>
                                                    <li class="booked mb-3"><a href="#">4:00 PM</a></li>
                                                    <li class="mb-3"><a href="#">4:30 PM</a></li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="error-massge text-center mt-5 border-radius-10">
                                            <p>You have already a appointment on this day</p>
                                        </div>
                                        <div class="mt-5 button-bottom d-flex justify-content-center"><router-link to="/check-consultation" class="btn btn-blue save">Confirm Appointment</router-link></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- End of Page Wrapper -->
    </div>
</template>
<script>
    export default {
        name: "calendly-calendar-book",
        data() {
            return {};
        },
        created(){
           this.pageName('Consultation')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/consultant/calendly-calendar-book.vue